export const REFERENCE_ID = 'loom';
export const HAMS_PRODUCT_ID = 'loom';
export const PRODUCT_NAME = 'Loom';
export const CCP_PRODUCT_ID = '7683a73e-423d-41a1-b43f-d497656f8b5d';
export const LOGO_URL =
	'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/logos/contrib/loom/icons-sml/blue.svg';
